<template>
  <div class="p-4">
    <div class="d-flex align-items-center mb-3">
      <i class="fas fa-check-circle mr-2 text-orange"></i>
      <div class="color-gray-7 font-16 font-weight-bold">
        Enviar a ruta
      </div>
    </div>
    <validation-observer ref="observer" novalidate>
      <div class="row">
        <div class="col-12 col-md">
          <div class="color-secondary-6 font-14 font-weight-normal mb-2">
            Fecha de Envío:
          </div>
          <validation-provider
            class="w-100"
            rules="required"
            name="Fecha de Envío"
            v-slot="{ errors }"
          >
            <custom-date-picker
              placeholder="DD/MM/YYYY"
              container-class="w-100"
              v-model="model.sendDate"
              :min-date="minDate"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md">
          <div class="color-secondary-6 font-14 font-weight-normal mb-2">
            Dirección de Envío:
          </div>
          <validation-provider
            class="w-100"
            name="Dirección de Envío"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-input
              type="text"
              placeholder="Escriba dirección de envío"
              :error="errors[0]"
              v-model="model.sendAddress"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md">
          <div class="color-secondary-6 font-14 font-weight-normal mb-2">
            Asignado a:
          </div>
          <validation-provider
            class="w-100"
            rules="required"
            name="Asignado a"
            v-slot="{ errors }"
          >
            <custom-input
              v-model="model.assignedTo"
              placeholder="Escriba nombre del asignado"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mb-2">
            Comentario:
          </div>
          <validation-provider
            class="w-100"
            rules="required"
            name="Comentario"
            v-slot="{ errors }"
          >
            <custom-text-area
              v-model="model.comment"
              :custom-error-msg="errors[0]"
              placeholder="Escriba un comentario"
              :maxlength="3000"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>

    <div class="d-flex justify-content-end mt-4">
      <action-button
        :variant="'outline-danger ' + (isMobile ? 'w-100  mt-4' : 'mr-2')"
        type="button"
        i="fas fa-times-circle"
        @click="cancel"
      >
        Cancelar
      </action-button>
      <action-button
        :variant="'success ' + (isMobile ? 'w-100  mt-4' : '')"
        type="button"
        i="fas fa-save"
        @click="save"
      >
        Guardar
      </action-button>
    </div>
  </div>
</template>
<script>
import mixAlert from '@/mixins/alert.mixin';
import CustomTextArea from '@quisit/custom-text-area';
import CustomDatePicker from 'custom-date-picker';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import service from '@/services/api/inventorycatalog.api';

import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import utils from '@/utils/utilities';

extend('email', {
  ...email,
  message: (field) => `El campo ${field} es un correo electrónico inválido`,
});

extend('required', {
  ...required,
  message: (field) => `El campo ${field} es requerido`,
});

export default {
  name: 'SendToRoute',
  components: {
    CustomTextArea,
    CustomDatePicker,
    CustomInput,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: {
        sendDate: null,
        sendAddress: null,
        assignedTo: null,
        comment: null,
      },
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    minDate() {
      if (!this.item?.determination) return utils.yesterday();
      return utils.subtract(this.item.determination.date, 1, 'days');
    },
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async save() {
      try {
        const valid = await this.$refs.observer.validate();
        if (!valid) return;
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea enviar a ruta la solicitud?`,
          'Sí',
          'No'
        );

        if (!confirmed) return;
        await service.sendToRouteInventoryTransfer(this.item.id, this.model);
        this.ShowToast(
          'Éxito',
          'La transferencia se ha enviado a ruta exitosamente.',
          'success'
        );
        this.$emit('refresh');
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .custom-datetime-picker-container.width-container {
  width: 100% !important;
}
</style>
